import React from "react";
import {Container, Row} from "reactstrap";
import "../scss/Home.css";

const CURRENCY_SYMBOL = "R ";

const CARD_CONFIG = [
    {
        "name": "transactionCountToday",
        "title": "Transaction No.",
        "width": "5px"
    },
    {
        "name": "transactionSumToday",
        "title": "Transaction Value",
        "prepend": CURRENCY_SYMBOL
    },
    {
        "name": "transactionCountMonth",
        "title": "Transaction No."
    },
    {
        "name": "transactionSumMonth",
        "title": "Transaction Value",
        "prepend": CURRENCY_SYMBOL
    },
    {
        "name": "registrationCount",
        "title": "Registrations Today"
    },
    {
        "name": "totalRegistrations",
        "title": "Total Registrations"
    }
];


export default class CardCreator extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            agentInfo: this.props.agentInfo,
            config: this.props.config
        }
    }

    renderCardValue(card) {
        return <div key={card.key} className={"welcome_card"}>
            <div className={"welcome_card_text"}>
                <span className={"welcome_card_header"}>
                    {card.title}<br/>
                </span>
                <span className={"welcome_card_value"}>
                    {this.state.agentInfo[card.name]}
                </span>
            </div>
        </div>
    }

    render() {

        return <Container style={{display: 'flex-box', flexDirection: 'row'}}>
            <Row>
                {/*<div className={"welcome_subheader"}>Today's Transactions</div>*/}
                {/*<div className={"welcome_card_group"}>*/}
                {/*    {this.renderCardValue(CARD_CONFIG[0])}*/}
                {/*    {this.renderCardValue(CARD_CONFIG[1])}*/}
                {/*</div>*/}
                {/*<div className={"welcome_subheader"}>This Month's Transactions</div>*/}
                {/*<div className={"welcome_card_group"}>*/}
                {/*    {this.renderCardValue(CARD_CONFIG[2])}*/}
                {/*    {this.renderCardValue(CARD_CONFIG[3])}*/}
                {/*</div>*/}
                <div className={"welcome_subheader"}>Registrations</div>
                <div className={"welcome_card_group"}>
                    {this.renderCardValue(CARD_CONFIG[4])}
                    {this.renderCardValue(CARD_CONFIG[5])}
                </div>
            </Row>
        </Container>
    }

}